import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useStoProject } from './useStoProject'
import { stoQueries } from './queries/stoQueries'
import { pickContent, StoContentTypes } from 'models/projectContent'
import { toNavCompositions, type NavCompositionContent, type NavComposition } from 'models/navComposition'
import { GOLD_CURRENCY } from 'models/productChart'

/**
 * A fund's NAV composition by month, newest first, per currency: XAUt first when back-office has
 * it (Goldstream), then the fund's own. From the page's single project-content request (SSR'd).
 */
export function useNavComposition(): NavComposition[] {
  const { project, projectId } = useStoProject()
  const { data } = useQuery(stoQueries.content(projectId))
  const currency = project?.tokenCurrency?.trim() || 'USD'
  return useMemo(
    () =>
      toNavCompositions(
        pickContent<NavCompositionContent>(data, StoContentTypes.NAV_COMPOSITION),
        currency,
        GOLD_CURRENCY,
      ),
    [data, currency],
  )
}
